/* @flow */
import { asyncAction, syncAction } from 'lib/action';

export const getStatementTxnSearchAction = asyncAction('googleSerch/GOOGLE_SEARCH');
export const setGoogleSearchTextAction = syncAction('googleSerch/SET_GOOGLE_SEARCH_TEXT');
export const setGooglePanelStatusAction = syncAction('googleSerch/SET_GOOGLE_PANEL_STATUS');
